import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { ElementPropertyTargetType } from "../properties";

export const ElementView = z.object({
  id: z.string(),
  persistentId: z.string(),
  designSystemVersionId: z.string(),
  name: z.string(),
  description: z.string(),
  targetElementType: ElementPropertyTargetType,
  isDefault: z.boolean(),
});

export type ElementView = z.infer<typeof ElementView>;

export type CreateElementView = DbCreateInputOmit<ElementView>;
export type UpdateElementView = OmitStrict<DbUpdate<ElementView>, "designSystemVersionId" | "targetElementType">;
